import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/ScrollToTop';
import AuroraBackground from './components/ui/AuroraBackground';

const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const VpsPage = lazy(() => import('./pages/VpsPage'));
const ReverseProxyPage = lazy(() => import('./pages/ReverseProxyPage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const CfxFinderPage = lazy(() => import('./pages/CfxFinderPage'));
const CdnCachingPage = lazy(() => import('./pages/CdnCachingPage'));
const GamePanelPage = lazy(() => import('./pages/GamePanelPage'));
const VpsWindowsPage = lazy(() => import('./pages/VpsWindowsPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const ArticlePage = lazy(() => import('./pages/ArticlePage'));
const ComparaisonPage = lazy(() => import('./pages/ComparaisonPage'));

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col bg-dark text-white relative">
          {/* Global background effects */}
          <div className="fixed inset-0 z-0 pointer-events-none">
            <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-transparent to-transparent opacity-30" />
            <div className="absolute -top-32 -left-20 w-[420px] h-[420px] rounded-full opacity-30"
                 style={{ background: 'radial-gradient(circle, rgba(124,58,237,0.15) 0%, transparent 70%)' }} />
            <div className="absolute top-40 -right-24 w-[460px] h-[460px] rounded-full opacity-30"
                 style={{ background: 'radial-gradient(circle, rgba(168,85,247,0.15) 0%, transparent 70%)' }} />
            <div className="absolute inset-0 opacity-[0.04] bg-grid-pattern" />
          </div>
          <AuroraBackground />
          <Header />
          <div className="flex-grow pt-24 relative z-10">
            <Suspense fallback={<div className="min-h-screen" />}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/services/vps" element={<VpsPage />} />
                <Route path="/services/reverse-proxy" element={<ReverseProxyPage />} />
                <Route path="/services/cdn-caching" element={<CdnCachingPage />} />
                <Route path="/services/game-panel" element={<GamePanelPage />} />
                <Route path="/services/vps-windows" element={<VpsWindowsPage />} />
                <Route path="/cfx-finder" element={<CfxFinderPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/:slug" element={<ArticlePage />} />
                <Route path="/comparatif" element={<ComparaisonPage />} />
                <Route path="/fivemshield-vs-zap-hosting" element={<ComparaisonPage />} />
                <Route path="/legal" element={<LegalPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </div>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
